import axios from 'axios';
import instanceConfig from './instanceConfig';
import url from './url';

const languages = {
  de: 'lang/de.json',
  en: 'lang/en.json'
};

let wordings = {};
let fetched = false;

const get = function() {
  if (fetched) {
    return Promise.resolve(wordings[instanceConfig.getCurrentLang()]);
  }

  return new Promise((resolve, reject) => {
    let lp = [];
    for (let [lang, source] of Object.entries(languages)) {
      lp.push(axios
        .get(url.randomize(source))
        .then(response => {
          wordings[lang] = response.data;
        }))
    }
    resolve(Promise.all(lp).then(() => {
      fetched = true;
      return wordings[instanceConfig.getCurrentLang()];
    }));
  });
};

function getLoaded() {
  return wordings[instanceConfig.getCurrentLang()];
}

export default get;

export { getLoaded };



// WEBPACK FOOTER //
// ./src/utils/wordings.js